import React from 'react'
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../../redux/library/selector';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';

export default function TenantDomainFunctionEntityBasicInfoComponent ({domainDetails,parentEntity,domain,parentDomain,handleInnerFormChange, selectedDomainEntity}: any) {
    const libraryData = useSelector(selectListItems)
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

<InputContainer
                  label="Feature Name"
                  labelField="Name"
                  list={parentDomain}
                  onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                       'FeatureId'
                       );
                  }}
                  optionName ="Choose Feature Name"
                  type="select"
                  value={selectedDomainEntity?.FeatureId}
                  valueField="Id"
              />

<InputContainer
                  label="Function Name"
                  labelField="FunctionName"
                  list={domain}
                  onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                       'FunctionId'
                       );
                  }}
                  optionName ="Choose Function Name"
                  type="select"
                  value={selectedDomainEntity?.FunctionId}
                  valueField="Id"
              />

<InputContainer

label="Sub Entity"
name="IsParent"
onValueChange={(event: any) => {
    handleInnerFormChange(
        event,
       'IsParent'
       );
}}
type="checkbox"
value={selectedDomainEntity?.IsParent}
/>

{selectedDomainEntity?.IsParent === true &&
       <InputContainer
       label="Parent Entity"
       labelField="EntityName"
       list={parentEntity}
       onValueChange={(event: any, newValue: any) => {
        handleInnerFormChange(
            event.target.value,
           'ParentEntityId'
           );
       }}
       optionName="Choose Parent Entity"
       type="select"
       value={selectedDomainEntity?.ParentEntityId}
       valueField="Id"
   />
  }
           <InputContainer

            label="Entity Name"
            name="EntityName"
            onValueChange={(event: any) => {
                handleInnerFormChange(
                    event.target.value,
                   'EntityName'
                   );
            }}
            type="text"
            value={selectedDomainEntity?.EntityName}
            />
        
        <InputContainer
                 label="Domain Name"
                 labelField="Name"
                 list={domainDetails}
                 onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'DomainId',
  
                  )
                 }}
                 optionName="Choose Domain"
                 type="select"
                 value={selectedDomainEntity?.DomainId}
                 valueField="Id"
             />
      
      <InputContainer

label="Code"
name="Code"
onValueChange={(event: any) => {
    handleInnerFormChange(
        event.target.value,
       'Code'
       );
}}
type="text"
value={selectedDomainEntity?.Code}
/>

   <InputContainer
                 label="Entity Type"
                 labelField="Text"
                 list={libraryData?.result?.DomainType}
                 onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                       'EntityTypeId'
                       );
                 }}
                 optionName ="Choose Entity Type"
                 type="select"
                 value={selectedDomainEntity?.EntityTypeId}
                 valueField="Value"
             />
              <InputContainer
                 label="Entity Level"
                 labelField="Text"
                 list={libraryData?.result?.DomainLevel}
                 onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                       'EntityLevelId'
                       );
                 }}
                 optionName ="Choose Entity Level"
                 type="select"
                 value={selectedDomainEntity?.EntityLevelId}
                 valueField="Value"
             />

<InputContainer

label="Active"
name="IsActive"
onValueChange={(event: any) => {
    handleInnerFormChange(
        event,
       'IsActive'
       );
}}
type="checkbox"
value={selectedDomainEntity?.IsActive}
/>

<InputContainer

    label="Tag Allowed"
    name="IsTagAllowed"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
           'IsTagAllowed'
           );
    }}
    type="checkbox"
    value={selectedDomainEntity?.IsTagAllowed}
/>

<InputContainer

    label="TenantEntityAttributeAllowed"
    name="IsTenantEntityAttributeAllowed"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
           'IsTenantEntityAttributeAllowed'
           );
    }}
    type="checkbox"
    value={selectedDomainEntity?.IsTenantEntityAttributeAllowed}
/>
<InputContainer

label="Folder"
name="HasFolder"
onValueChange={(event: any) => {
    handleInnerFormChange(
        event,
       'HasFolder'
       );
}}
type="checkbox"
value={selectedDomainEntity?.HasFolder}
/>
</div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}